/* ==========================================================================
   PRANA+ — comportamiento propio (JavaScript sin librerias externas)
   Una funcion por componente; cada una sale sola si su elemento no existe.
   ========================================================================== */

(function () {
  'use strict';

  var menosMovimiento =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* --- Entradas al hacer scroll (un solo observador compartido) ---------- */
  function initReveal() {
    var elementos = document.querySelectorAll('.pr-reveal:not(.pr-visible)');
    if (!elementos.length) return;

    if (menosMovimiento || !('IntersectionObserver' in window)) {
      elementos.forEach(function (el) {
        el.classList.add('pr-visible');
      });
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          var el = entrada.target;
          var retardo = parseInt(el.getAttribute('data-pr-retardo') || '0', 10);
          setTimeout(function () {
            el.classList.add('pr-visible');
          }, retardo);
          observador.unobserve(el);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    elementos.forEach(function (el) {
      observador.observe(el);
    });
  }

  /* --- Cifras que cuentan hacia arriba ---------------------------------- */
  function initCifras() {
    var cifras = document.querySelectorAll('[data-pr-contador]');
    if (!cifras.length) return;

    function pintar(el, valor, decimales) {
      var texto = decimales
        ? valor.toFixed(decimales)
        : Math.round(valor).toLocaleString('en-US');
      el.textContent =
        (el.getAttribute('data-pr-antes') || '') +
        texto +
        (el.getAttribute('data-pr-despues') || '');
    }

    function animar(el) {
      var destino = parseFloat(el.getAttribute('data-pr-contador')) || 0;
      var decimales = (String(destino).split('.')[1] || '').length;

      if (menosMovimiento) {
        pintar(el, destino, decimales);
        return;
      }

      var duracion = 1600;
      var inicio = null;

      function paso(ahora) {
        if (inicio === null) inicio = ahora;
        var t = Math.min((ahora - inicio) / duracion, 1);
        var suave = 1 - Math.pow(1 - t, 3);
        pintar(el, destino * suave, decimales);
        if (t < 1) requestAnimationFrame(paso);
      }

      requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      cifras.forEach(animar);
      return;
    }

    var observador = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          animar(entrada.target);
          observador.unobserve(entrada.target);
        });
      },
      { threshold: 0.5 }
    );

    cifras.forEach(function (el) {
      observador.observe(el);
    });
  }

  /* --- Parallax suave del hero ------------------------------------------ */
  function initParallax() {
    var capas = document.querySelectorAll('[data-pr-parallax]');
    if (!capas.length || menosMovimiento) return;
    if (window.innerWidth < 990) return;

    var pendiente = false;

    function actualizar() {
      pendiente = false;
      capas.forEach(function (capa) {
        var fuerza = parseFloat(capa.getAttribute('data-pr-parallax')) || 0;
        if (!fuerza) return;
        var caja = capa.getBoundingClientRect();
        var centro = caja.top + caja.height / 2 - window.innerHeight / 2;
        capa.style.transform =
          'translate3d(0,' + (-centro * fuerza * 0.06).toFixed(2) + 'px,0)';
      });
    }

    window.addEventListener(
      'scroll',
      function () {
        if (pendiente) return;
        pendiente = true;
        requestAnimationFrame(actualizar);
      },
      { passive: true }
    );

    actualizar();
  }

  /* --- Galeria de la pagina de producto --------------------------------- */
  function initGaleriaProducto() {
    var galeria = document.querySelector('[data-pr-galeria]');
    if (!galeria) return;

    var principal = galeria.querySelector('[data-pr-galeria-principal]');
    var minis = galeria.querySelectorAll('[data-pr-galeria-mini]');
    if (!principal || !minis.length) return;

    minis.forEach(function (mini) {
      mini.addEventListener('click', function () {
        var url = mini.getAttribute('data-pr-url');
        var alt = mini.getAttribute('data-pr-alt') || '';
        if (!url) return;
        principal.setAttribute('src', url);
        principal.setAttribute('alt', alt);
        minis.forEach(function (otra) {
          otra.classList.remove('is-activa');
        });
        mini.classList.add('is-activa');
      });
    });
  }

  /* --- Selector de cantidad --------------------------------------------- */
  function initCantidad() {
    var cajas = document.querySelectorAll('[data-pr-cantidad]');
    if (!cajas.length) return;

    cajas.forEach(function (caja) {
      var campo = caja.querySelector('input');
      if (!campo) return;

      caja.addEventListener('click', function (evento) {
        var boton = evento.target.closest('[data-pr-paso]');
        if (!boton) return;
        evento.preventDefault();
        var paso = parseInt(boton.getAttribute('data-pr-paso'), 10) || 0;
        var valor = (parseInt(campo.value, 10) || 1) + paso;
        campo.value = Math.max(1, valor);
        campo.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  /* --- Oferta por cantidad ----------------------------------------------
     Al elegir un pack solo cambiamos la cantidad del formulario. Los precios
     los calcula el servidor, así que aquí no se toca ningún importe: no hay
     forma de que la página y el catálogo digan cosas distintas.
     ---------------------------------------------------------------------- */
  function initPacks() {
    var caja = document.querySelector('[data-pr-packs]');
    if (!caja) return;

    var opciones = caja.querySelectorAll('[data-pr-pack]');
    if (!opciones.length) return;

    var campo = document.querySelector('[data-pr-cantidad] input[name="quantity"]');

    function elegir(boton) {
      opciones.forEach(function (o) {
        o.classList.remove('is-activo');
        o.setAttribute('aria-pressed', 'false');
      });
      boton.classList.add('is-activo');
      boton.setAttribute('aria-pressed', 'true');

      var cantidad = parseInt(boton.getAttribute('data-pr-pack-cantidad'), 10) || 1;
      if (campo) {
        campo.value = cantidad;
        campo.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    opciones.forEach(function (boton) {
      boton.setAttribute('aria-pressed', boton.classList.contains('is-activo') ? 'true' : 'false');
      boton.addEventListener('click', function () {
        elegir(boton);
      });
    });

    // Si el cliente cambia la cantidad a mano, deseleccionamos el pack que ya
    // no corresponde para no mentirle con el precio marcado.
    if (campo) {
      campo.addEventListener('change', function () {
        var v = parseInt(campo.value, 10) || 1;
        var coincide = null;
        opciones.forEach(function (o) {
          if (parseInt(o.getAttribute('data-pr-pack-cantidad'), 10) === v) coincide = o;
        });
        opciones.forEach(function (o) {
          o.classList.toggle('is-activo', o === coincide);
          o.setAttribute('aria-pressed', o === coincide ? 'true' : 'false');
        });
      });
    }

    // Arrancar con el pack marcado como activo en el HTML
    var inicial = caja.querySelector('[data-pr-pack].is-activo') || opciones[0];
    if (inicial) elegir(inicial);
  }

  /* --- Variantes del producto ------------------------------------------- */
  function initVariantes() {
    var bloque = document.querySelector('[data-pr-variantes]');
    if (!bloque) return;

    var datos = bloque.querySelector('[data-pr-variantes-json]');
    if (!datos) return;

    var variantes;
    try {
      variantes = JSON.parse(datos.textContent);
    } catch (e) {
      return;
    }
    if (!Array.isArray(variantes) || !variantes.length) return;

    var botones = bloque.querySelectorAll('[data-pr-opcion]');
    var campoId = bloque.querySelector('[data-pr-variante-id]');
    var precio = bloque.querySelector('[data-pr-precio]');
    var precioAntes = bloque.querySelector('[data-pr-precio-antes]');
    var ahorro = bloque.querySelector('[data-pr-ahorro]');
    var submit = bloque.querySelector('[data-pr-submit]');
    // El botón lleva dentro un <span> (y el girador de carga de Dawn):
    // hay que tocar solo el texto del span, nunca el botón entero.
    var submitTexto = submit ? submit.querySelector('span') || submit : null;
    var textoAgotado = bloque.getAttribute('data-pr-texto-agotado') || 'Agotado';
    var textoComprar = submit ? submit.getAttribute('data-pr-texto') : '';
    var formatoMoneda = bloque.getAttribute('data-pr-formato') || '${{amount}}';

    function dinero(centavos) {
      var valor = (centavos / 100).toFixed(2);
      var partes = valor.split('.');
      // Formato anglosajon (USD): 1,234.56
      var enteroUS = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var usConDecimales = enteroUS + '.' + partes[1];
      // Formato europeo/latino: 1.234,56
      var enteroEU = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      var euConDecimales = enteroEU + ',' + partes[1];
      // Cada marcador de Shopify pide un formato distinto: hay que respetarlos.
      return formatoMoneda
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, enteroEU)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, euConDecimales)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, enteroUS)
        .replace(/\{\{\s*amount\s*\}\}/g, usConDecimales);
    }

    function seleccionActual() {
      var elegidas = [];
      bloque.querySelectorAll('[data-pr-grupo-opcion]').forEach(function (grupo) {
        var activo = grupo.querySelector('.is-activo');
        elegidas.push(activo ? activo.getAttribute('data-pr-valor') : null);
      });
      return elegidas;
    }

    function aplicar() {
      var elegidas = seleccionActual();
      var encontrada = variantes.find(function (variante) {
        return elegidas.every(function (valor, indice) {
          return valor === null || variante.opciones[indice] === valor;
        });
      });

      if (!encontrada) {
        if (submit) {
          submit.disabled = true;
          submit.setAttribute('aria-disabled', 'true');
          submitTexto.textContent = textoAgotado;
        }
        return;
      }

      if (campoId) campoId.value = encontrada.id;

      if (precio) precio.textContent = dinero(encontrada.precio);

      if (precioAntes) {
        if (encontrada.precio_antes && encontrada.precio_antes > encontrada.precio) {
          precioAntes.textContent = dinero(encontrada.precio_antes);
          precioAntes.hidden = false;
          if (ahorro) {
            var pct = Math.round(
              ((encontrada.precio_antes - encontrada.precio) /
                encontrada.precio_antes) *
                100
            );
            ahorro.textContent = '-' + pct + '%';
            ahorro.hidden = false;
          }
        } else {
          precioAntes.hidden = true;
          if (ahorro) ahorro.hidden = true;
        }
      }

      if (submit) {
        submit.disabled = !encontrada.disponible;
        submit.setAttribute('aria-disabled', encontrada.disponible ? 'false' : 'true');
        submitTexto.textContent = encontrada.disponible ? textoComprar : textoAgotado;
      }
    }

    botones.forEach(function (boton) {
      boton.addEventListener('click', function (evento) {
        evento.preventDefault();
        var grupo = boton.closest('[data-pr-grupo-opcion]');
        if (!grupo) return;
        grupo.querySelectorAll('[data-pr-opcion]').forEach(function (otro) {
          otro.classList.remove('is-activo');
        });
        boton.classList.add('is-activo');
        aplicar();
      });
    });

    aplicar();
  }

  /* --- Arranque ---------------------------------------------------------- */
  function arrancar() {
    initReveal();
    initCifras();
    initParallax();
    initGaleriaProducto();
    initCantidad();
    initPacks();
    initVariantes();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar, { once: true });
  } else {
    arrancar();
  }

  /* Reaccionar a los cambios del editor visual de Shopify */
  document.addEventListener('shopify:section:load', arrancar);
  document.addEventListener('shopify:section:select', arrancar);
})();
